import forEach from "./customForEach";
import postData from "./postData";
import setRussianErrorMessage from "./setRussianErrorMessage";

function initJsModalSubmitReview() {
    forEach(
        document.querySelectorAll(".js-modal-submit-review"),
        function (index, form) {
            const form_button = form.querySelector(".js-submit-form");
            const formInput = document.getElementById("review-input");
            if (formInput) {
                setRussianErrorMessage(formInput);
            }
            let form_button_t = "";
            if (form_button) {
                form_button_t = form_button.innerHTML;
            }
            form.addEventListener("submit", (event) => {
                event.preventDefault();
                form_button.innerHTML = "Отправка...";
                form_button.disabled = true;

                let msg_el = form.querySelector(".message");
                let optionalFields = {
                    rev_internet: "[name=rev_internet]:checked",
                    rev_stable: "[name=rev_stable]:checked",
                    rev_help: "[name=rev_help]:checked",
                    rev_equip: "[name=rev_equip]:checked",
                    merits: "[name=merits]",
                    demerits: "[name=demerits]",
                };

                const smartTokenField = form.querySelector("[name=smart-token]");

                let request = {
                    _token: form.querySelector("[name=_token]").value,
                    provider: form.querySelector("[name=provider]").value,
                    rev_main: form.querySelector("[name=rev_main]:checked")
                        ? form.querySelector("[name=rev_main]:checked").value
                        : null,
                    review: form.querySelector("[name=review]").value,
                    yandex_token: smartTokenField && smartTokenField.value,
                };

                Object.keys(optionalFields).forEach(function (fieldName) {
                    let el = form.querySelector(optionalFields[fieldName]);
                    if (el && el.value) {
                        request[fieldName] = el.value;
                    }
                });

                postData(form.getAttribute("action"), request)
                    .then((data) => {
                        if (!data.success) {
                            let errorsMessages = "";

                            if (Array.isArray(data.errors)) {
                                errorsMessages = data.errors.join("<br />");
                            }

                            msg_el.innerHTML =
                                `<span class="error">` +
                                errorsMessages +
                                `</span>`;
                        } else {
                            msg_el.innerHTML = `<span class="success">Спасибо за отзыв!</span>`;

                            const reviewSuccessModal = document.getElementById('review-success-modal');
                            const reviewModal = document.getElementById('review-modal');

                            if (reviewModal) {
                                reviewModal.classList.remove('active');
                            }

                            if (reviewSuccessModal) {
                                reviewSuccessModal.classList.add('active');
                            }

                            form.reset();

                            const radioButtons = form.querySelectorAll('input[type="radio"]:checked');

                            radioButtons.forEach(radio => {
                                radio.checked = false;
                            });

                            const textFields = form.querySelectorAll('input[type="text"], textarea');

                            textFields.forEach(field => {
                                field.value = '';
                            });

                            setTimeout(() => {
                                msg_el.innerHTML = '';

                            }, 3000)
                        }

                        form_button.innerHTML = form_button_t;
                    })
                    .catch(function (error) {
                        msg_el.innerHTML = `<span class="error">Не удалось оставить отзыв, попробуйте позже.</span>`;
                        form_button.innerHTML = form_button_t;
                    })
                    .finally(function() {
                            form_button.disabled = false;
                        });
            });
        }
    );
}

export default initJsModalSubmitReview;
